// Local translations
export const T = {
  en_GB: {
    // Dialog
    editTitle: "Edit Risk Model",
    createTitle: "Create Risk Model",
    editDescription: "Update the name and description of your risk model.",
    createDescription: "Choose a template to get started quickly, or create a blank model.",
    // Templates
    chooseTemplate: "Choose a template",
    templateSimple: "Simple",
    templateSimpleSubtitle: "3x3 matrix - Scores 1-3",
    templateSimpleDescription:
      "Quick profiling with 3 portfolio outcomes. Best for straightforward client categorization into Conservative, Balanced, or Growth portfolios.",
    templateSimpleDefaultName: "Simple Risk Model",
    templateStandard: "Standard (SRRI)",
    templateStandardSubtitle: "3x3 matrix - Scores 1-7",
    templateStandardDescription:
      "EU-compliant risk profiling aligned with SRRI fund risk levels. Maps clients to standardized 1-7 scale used by UCITS funds.",
    templateStandardDefaultName: "SRRI Risk Model",
    templateDetailed: "Detailed",
    templateDetailedSubtitle: "4x5 matrix - Scores 1-10",
    templateDetailedDescription:
      "Comprehensive profiling with granular risk differentiation. 4 risk levels and 5 time horizons for precise client matching.",
    templateDetailedDefaultName: "Detailed Risk Model",
    templateBlank: "Blank",
    templateBlankSubtitle: "Start from scratch",
    templateBlankDescription:
      "Create an empty model and configure time horizons, risk levels, and scores manually.",
    // Form
    name: "Name",
    namePlaceholder: "e.g., Investment Risk Model",
    description: "Description (optional)",
    descriptionPlaceholder: "Describe what this risk model is used for",
    // Alerts
    error: "Error",
    failedToSave: "Failed to save risk model",
    // Actions
    cancel: "Cancel",
    save: "Save",
    create: "Create",
  },
  nb_NO: {
    // Dialog
    editTitle: "Rediger risikomodell",
    createTitle: "Opprett risikomodell",
    editDescription: "Oppdater navnet og beskrivelsen av risikomodellen din.",
    createDescription: "Velg en mal for å komme raskt i gang, eller opprett en tom modell.",
    // Templates
    chooseTemplate: "Velg en mal",
    templateSimple: "Enkel",
    templateSimpleSubtitle: "3x3 matrise - Skår 1-3",
    templateSimpleDescription:
      "Rask profilering med 3 porteføljeresultater. Best for enkel kundekategorisering i konservative, balanserte eller vekstporteføljer.",
    templateSimpleDefaultName: "Enkel risikomodell",
    templateStandard: "Standard (SRRI)",
    templateStandardSubtitle: "3x3 matrise - Skår 1-7",
    templateStandardDescription:
      "EU-kompatibel risikoprofilering tilpasset SRRI-fondsrisiko. Kartlegger kunder til standardisert 1-7 skala brukt av UCITS-fond.",
    templateStandardDefaultName: "SRRI-risikomodell",
    templateDetailed: "Detaljert",
    templateDetailedSubtitle: "4x5 matrise - Skår 1-10",
    templateDetailedDescription:
      "Omfattende profilering med detaljert risikofordeling. 4 risikonivåer og 5 tidshorisonter for presis kundetilpasning.",
    templateDetailedDefaultName: "Detaljert risikomodell",
    templateBlank: "Tom",
    templateBlankSubtitle: "Start fra bunnen",
    templateBlankDescription:
      "Opprett en tom modell og konfigurer tidshorisonter, risikonivåer og poeng manuelt.",
    // Form
    name: "Navn",
    namePlaceholder: "f.eks. Investerings-risikomodell",
    description: "Beskrivelse (valgfritt)",
    descriptionPlaceholder: "Beskriv hva denne risikomodellen brukes til",
    // Alerts
    error: "Feil",
    failedToSave: "Kunne ikke lagre risikomodell",
    // Actions
    cancel: "Avbryt",
    save: "Lagre",
    create: "Opprett",
  },
} as const;
